import { getAvailableProductVariants } from '~/utils/products'

export const getAvailableMerchSkus = (merch) => {
  const { kit, product } = merch

  if (product) {
    return getAvailableProductVariants(product)
  } else if (!kit.noIndividualPurchase) {
    return [kit]
  }
}
